import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import AnimatedSpotInnovation from '@utilitywarehouse/hearth-json-assets/lib/animated-spot-innovation-light.json';
import { Box } from '@utilitywarehouse/hearth-react';
import { useEffect } from 'react';

import { Dialog, DialogID, useDialog } from '@components/Dialog';

interface FindingDialogProps {
  open: boolean;
  canUpdateState: boolean;
}

interface FindingDialogUIProps {
  dialogId: DialogID;
}

const FindingDialogUI = ({ dialogId }: FindingDialogUIProps) => (
  <Dialog
    id={dialogId}
    heading="Finding your broadband details..."
    image={
      <Box width="120px" height="135px">
        <DotLottieReact data={AnimatedSpotInnovation} loop autoplay />
      </Box>
    }
    hideCloseButton
    preventDismiss
  />
);

const FindingDialog: React.FC<FindingDialogProps> = ({
  open,
  canUpdateState,
}) => {
  const { setOpen, id } = useDialog(DialogID.FINDING_OTS);

  useEffect(() => {
    if (canUpdateState && open) {
      setOpen(true);
    } else if (canUpdateState) {
      setOpen(false);
    }
  }, [canUpdateState, open, setOpen]);

  return <FindingDialogUI dialogId={id} />;
};

export type { FindingDialogProps, FindingDialogUIProps };

export { FindingDialog, FindingDialogUI };
